export default "__VITE_ASSET__Cw0Kylfa__"